module.exports = __webpack_public_path__ + "img/fashion_74.e25e0ae9.jpg";